/** Parses user-typed decimals; accepts "," as the decimal separator (fi/EU
 *  keypads) and at most two decimals, so "1,250" is rejected rather than
 *  silently read as 1.25. */
export function parseDecimalInput(raw: string): number | null {
  const s = raw.trim().replace(",", ".");
  if (!/^-?\d*(\.\d{0,2})?$/.test(s) || !/\d/.test(s)) return null;
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}

/** Empty or non-positive input is null, never 0. */
export function parsePositiveDecimalInput(raw: string): number | null {
  const n = parseDecimalInput(raw);
  return n != null && n > 0 ? n : null;
}

export function parsePositiveIntegerInput(raw: string): number | null {
  const n = parsePositiveDecimalInput(raw);
  return n != null && Number.isInteger(n) ? n : null;
}
